var map = {
	"./arm.svg": "7844",
	"./azr.svg": "8196",
	"./blr.svg": "3a89",
	"./est.svg": "2fde",
	"./gbr.svg": "4312",
	"./geo.svg": "d4e4",
	"./ind.svg": "a439",
	"./isr.svg": "ccd4",
	"./kaz.svg": "e41c",
	"./kgz.svg": "ca6e",
	"./kor.svg": "edeb",
	"./ltu.svg": "2e71",
	"./lva.svg": "24e5",
	"./mda.svg": "780c",
	"./pan.svg": "05c6",
	"./rus.svg": "422f",
	"./tha.svg": "bd5f",
	"./tjk.svg": "dede",
	"./tur.svg": "67c5",
	"./ukr.svg": "860e",
	"./uzb.svg": "10cb",
	"./vnm.svg": "0702"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1855";